<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.257 6.251a.842.842 0 0 0 0 1.208l4.504 4.418a.17.17 0 0 1 0 .247l-4.504 4.418a.84.84 0 0 0 0 1.208.887.887 0 0 0 1.235 0l5.248-5.146a.835.835 0 0 0 .26-.603.835.835 0 0 0-.26-.604L9.492 6.25a.88.88 0 0 0-1.235 0Z"
      fill="currentColor"
    />
  </svg>
</template>
